import React from 'react';
import PropTypes from 'prop-types';
import withRouter from 'HOCs/withRouter';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage as Translation } from 'react-intl';
import ReportModal from 'Components/ReportModal/ReportModal';
import { userIsLogged, getLoggedUser } from 'Selectors/user';
import withTrack from 'HOCs/withTrack/withTrack';
import Button from 'Components/Button/Button';
import css from './ReportUser.scss';
import classNames from 'classnames';
import { BLUELINK_BTN, OUTLINE_BTN, TERTIARY_BTN } from 'Constants/buttons';
import { TrackerOrigins } from 'Components/TrackerProvider/TrackerProvider';

export class ReportUser extends React.Component {
    static propTypes = {
        userIsLogged: PropTypes.bool.isRequired,
        params: PropTypes.object.isRequired,
        track: PropTypes.func.isRequired,
        userId: PropTypes.string.isRequired,
        loggedUser: PropTypes.object.isRequired,
        isClassified: PropTypes.bool,
        shiftReportLeft: PropTypes.bool
    };

    static defaultProps = {
        userIsLogged: false,
        shiftReportLeft: false,
        isClassified: false
    };

    constructor(props) {
        super(props);

        this.state = {
            openReportModal: false
        };
    }

    toggleReportModal = () => {
        this.setState({
            openReportModal: !this.state.openReportModal
        }, () => {
            if (this.state.openReportModal) {
                this.props.track('trust_tap_report_user_start', {
                    user_affected: this.props.params.userId
                });
            }
        });
    }

    renderModal = () => {
        const userId = this.props.userId;

        return (
            this.state.openReportModal
            && <ReportModal ID={ userId } onClick={ this.toggleReportModal } type="users" origin={ TrackerOrigins.PROFILE } />
        );
    }
    getBtntype({ isClassified, shiftReportLeft }) {
        if (shiftReportLeft) {
            return TERTIARY_BTN;
        }
        else if (isClassified) {
            return OUTLINE_BTN;
        }

        return BLUELINK_BTN;
    }

    render() {
        const { userIsLogged, userId, loggedUser, isClassified, shiftReportLeft } = this.props;

        const btnType = this.getBtntype({ isClassified, shiftReportLeft });

        return (
            <React.Fragment>
                { (userIsLogged && userId && userId !== loggedUser.id)
                    && <React.Fragment>
                        <Button
                            className={ classNames(css.reportUser, { [css.modernReportUser]: isClassified }) }
                            type={ btnType }
                            size="small"
                            fixed={ true }
                            onClick={ this.toggleReportModal }
                            data-aut-id="reportUser"
                            icon={ isClassified ? 'exclamationCircle' : null }
                        >
                            <Translation id="reportUserModalTitle" />
                        </Button>
                        { this.renderModal() }
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

export const mapStateToProps = state => {
    return {
        userIsLogged: userIsLogged(state),
        loggedUser: getLoggedUser(state)
    };
};

export default compose(
    withRouter,
    withTrack,
    connect(mapStateToProps)
)(ReportUser);
